import React, { Component } from "react";
import OrgChart from "./OrgChart.js";
import domain from "./domain";
/**
 * External Js of Orgnization Chart
 * <OrgChart url>
 */

class ProjectOrganizationChart extends Component {
  render() {
    return (
      <div>
        <OrgChart url={domain.orgChartURL} />
      </div>
    );
  }
}

export default ProjectOrganizationChart;
